import { render, staticRenderFns } from "./CommissionLists.vue?vue&type=template&id=b69c5646&scoped=true"
import script from "./CommissionLists.vue?vue&type=script&lang=js"
export * from "./CommissionLists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b69c5646",
  null
  
)

export default component.exports